import SiteLayout from '../../app/layout/SiteLayout';

export default SiteLayout;
